import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import { CoreService } from 'app/services/entidades/core.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class StatusService extends CoreService {

  constructor(
    private _http: Http
  ) {
    super(_http);
  }

  /**
   * Servicio para traer los indicadores del sistema
   * @param {number|null}  ID del estado que buscamos
   * @return {any} Retorna los indicadores
   */
  get(idestado: number = null): Observable<any> {
    if (idestado) {
      return this.getMethod(`indicators/${idestado}`);
    } else {
      return this.getMethod('indicators/');
    }
  }

  /**
   * Servicio para agregar indicadores de casos
   * @param {object} indicator Datos del indicador
   * @return {any} Retorna los datos del insert
   */
  add(indicator: any): Observable<any> {
    return this.postMethod('indicators/', indicator);
  }

  edit(estado: any): Observable<any> {
    return this.putMethod('indicators/', estado);
  }

  /**
   * Elimina un estado
   * @param  {number} idestado ID del estado a eliminar
   * @return {any}             Objeto json con la respuesta.
   */
  delete(idestado: number): Observable<any> {
    return this.deleteMethod(`indicators/${idestado}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/entidades/status.service.ts